import { createSelector } from '@ngrx/store';
import { getRedeemCashV2State, RedeemCashV2State } from '../reducers/index';
import { MembershipState } from '../reducers/membership.reducer';

const getMembershipState = createSelector(
  getRedeemCashV2State,
  (state: RedeemCashV2State) => state.membership,
);

const getCreateMembership = (state: MembershipState) => state.createMembership;
const getUpdateMembership = (state: MembershipState) => state.updateMembership;

export const getMembershipMemberships = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.data,
);

export const getMembershipsIsLoaded = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.isLoaded,
);

export const getMembershipError = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.error,
);

export const getMembershipLoading = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.loading,
);

export const getCreateMembershipSelector = createSelector(
  getMembershipState,
  getCreateMembership,
);

export const getUpdateMembershipSelector = createSelector(
  getMembershipState,
  getUpdateMembership,
);

export const getCreateMembershipIsLoading = createSelector(
  getCreateMembershipSelector,
  (state: MembershipState['createMembership']) => state.loading,
);

export const getCreateMembershipError = createSelector(
  getCreateMembershipSelector,
  (state: MembershipState['createMembership']) => state.error,
);

export const getUpdateMembershipIsLoading = createSelector(
  getUpdateMembershipSelector,
  (state: MembershipState['updateMembership']) => state.loading,
);

export const getUpdateMembershipError = createSelector(
  getUpdateMembershipSelector,
  (state: MembershipState['updateMembership']) => state.error,
);

export const getCreateOrUpdateMembershipIsLoading = createSelector(
  getCreateMembershipIsLoading,
  getUpdateMembershipIsLoading,
  (createIsLoading, updateIsLoading) => {
    return createIsLoading || updateIsLoading;
  },
);

// By right, both of these should not exist at the same time, so we can just consolidate both of them
export const getCreateOrUpdateMembershipError = createSelector(
  getCreateMembershipError,
  getUpdateMembershipError,
  (createError, updateError) => {
    return createError || updateError;
  },
);

export const getMembershipsOrUpdateMembershipIsLoading = createSelector(
  getMembershipLoading,
  getUpdateMembershipIsLoading,
  (membershipsLoading, updateIsLoading) => {
    return membershipsLoading || updateIsLoading;
  },
);
